<template>
  <div class="comp">
    <el-dialog
      :visible.sync="dialog_state"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <div class="title">充值</div>
        <div class="content">
          <div class="line">
            <div class="label">充值活动</div>
            <el-select
              class="select"
              v-model="curActivity"
              @change="changeActivity"
              placeholder="请选择"
            >
              <el-option
                popper-class="select"
                v-for="(item,index) in activityList"
                :key="'activity'+index"
                :label="item.activity_name"
                :value="index"
              ></el-option>
            </el-select>
          </div>
          <div class="detail">
            <div v-if="curActivity!==''">
              <div v-if="activityList[curActivity].give_services.length>0">
                <div style="font-size: 18px;margin-bottom:5px;">赠送服务:</div>
                <div
                  style="display: flex;padding-left:20px;"
                  v-for="(item,index) in activityList[curActivity].give_services"
                  :key="index"
                >
                  <div style="width:300px">{{item.service_name}}</div>
                  <div style="width:100px">￥{{item.price}}</div>
                  <div style="width:100px">{{item.consume_count}}次</div>
                  <div style="width:100px">{{item.days}}天</div>
                </div>
              </div>
              <div v-if="activityList[curActivity].give_goods.length>0">
                <div style="font-size: 18px;margin-bottom:5px;">赠送商品:</div>
                <div
                  style="display: flex;padding-left:20px;"
                  v-for="(item,index) in activityList[curActivity].give_goods"
                  :key="index"
                >
                  <div style="width:300px">{{item.goods_name}}</div>
                  <div style="width:200px">{{item.sku_value}}</div>
                  <div style="width:100px">￥{{item.price}}</div>
                  <div style="width:100px">{{item.goods_count}}个</div>
                </div>
              </div>
            </div>
          </div>
          <div class="line">
            <div class="label">顾客/手机号</div>
            <el-select
              class="select"
              v-model="curPeople"
              @change="changePeople"
              @visible-change="visibleChange"
              filterable
              remote
              reserve-keyword
              placeholder="请输入"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <!-- <el-option
                v-for="(item,index) in memberList"
                :key="item._id"
                :label="(item.club_card. surplus_day==0?'':'['+item.club_card. surplus_day+'星]')+item.basic_info.nick_name+'('+item.basic_info.user_mobile+')'"
                :value="index"
              ></el-option> -->
            </el-select>
          </div>
          <div class="detail">
            <div v-if="curPeople!==''">
              <div class="span">昵称:{{memberList[curPeople].basic_info.nick_name}}</div>
              <div class="span">手机:{{memberList[curPeople].basic_info.user_mobile}}</div>
              <div class="span">余额:{{memberList[curPeople].card_info.user_yue}}</div>
              <div class="span">赠额:{{memberList[curPeople].card_info.user_zenge}}</div>
            </div>
          </div>
          <div
            class="line"
            v-if="curActivity!==''&&activityList[curActivity].give_services.length>0&&curPeople!==''"
          >
            <div class="label">宠物</div>
            <el-select class="select" v-model="curPet" placeholder="请选择">
              <el-option
                v-for="(item,index) in memberList[curPeople].pets_info"
                :key="item._id"
                :label="item.nick_name+'('+item.type_name+')'"
                :value="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="detail"
            v-if="curActivity!==''&&activityList[curActivity].give_services.length>0&&curPeople!==''&&curPet!==''"
          >
            <div>
              <div class="span">昵称:{{memberList[curPeople].pets_info[curPet].nick_name}}</div>
              <div class="span">毛色:{{memberList[curPeople].pets_info[curPet].color}}</div>
            </div>
          </div>
          <div
            class="line"
            v-if="curActivity!==''&&activityList[curActivity].give_goods.length>0"
            style="display: block;"
          >
            <div style="padding:10px 0 20px;font-size: 22px;">
              赠送物品
              <span style="color:#409EFF;padding-left:10px;font-size: 16px;">（请扫描商品对应的条码）</span>
            </div>
            <el-row>
              <el-col :span="5">
                <el-input v-model="scanningCodeInput" placeholder="请输入条码">
                  <template slot="append">
                    <el-button type="danger" icon="el-icon-search" @click="clickScanningCodeInput"></el-button>
                  </template>
                </el-input>
              </el-col>
            </el-row>
            <el-table
              :data="tableData"
              max-height="600"
              style="width: 100%;margin-bottom: 20px;"
              row-key="customCode"
              :tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}"
            >
              <el-table-column prop="goodsName" label="名称" width="350"></el-table-column>
              <el-table-column prop="customCode" label="条码" width="250">
                <template slot-scope="scope">{{scope.row.goodsList?'':scope.row.customCode}}</template>
              </el-table-column>
              <!-- <el-table-column prop="price" label="价格" width="150">
              </el-table-column>-->
              <el-table-column prop="skuValue" label="规格"></el-table-column>
              <el-table-column prop="unit" label="单位" width="80"></el-table-column>
              <el-table-column prop="num" label="数量" width="60"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delNotGoods(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <img src="../assets/img/kong.png" style="width: 335px;padding-top:50px;" />
              </template>
            </el-table>
          </div>
          <div class="line">
            <div class="label" style="background-color: transparent;color:#1A1A1A">销售人员</div>
            <el-select class="select" multiple v-model="curStaff" filterable placeholder="请选择">
              <el-option
                popper-class="select"
                v-for="(item,index) in staffList"
                :key="item._id"
                :label="item.basic_info.nick_name"
                :value="index"
              ></el-option>
            </el-select>
          </div>
          <div class="detail"></div>
          <div class="line">
            <div class="label" style="background-color: transparent;color:#1A1A1A">备注</div>
            <el-input class="select" style="width:450px;" v-model="remark"></el-input>
          </div>
        </div>
        <div class="btns">
          <div class="cancel" @click="submit('cancel')">取消</div>
          <div class="submit" @click="submit('submit')">确定</div>
        </div>
      </div>
    </el-dialog>
    <!-- 结算弹窗 -->
    <div>
      <dialogSettlement
        v-if="dialogSettlementState"
        :type="'recharge'"
        :orderId="order._id"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
  </div>
</template>
<script>
import del from '../util/del.js'
import dialogSettlement from '@/components/dialog_settlement.vue'
export default {
  components: { dialogSettlement },
  data () {
    return {
      dialog_state: true,
      curActivity: '',
      activityList: [],
      curPeople: '',
      memberList: [],
      curPet: '',
      curStaff: [],  // 销售人员
      staffList: [],
      remark: '',    // 备注
      totalMoney: 0,  // 总价
      loading: false,
      tableData: [],    // 录入的商品列表
      scanningCode: '',
      scanningCodeInput: '',
      dialogSettlementState: false,
      order: {},
      o: null,
      cancelSource: null,
    }
  },
  mounted () {
    this.o = new del();
    this.o.init([])
    document.onkeypress = (e) => {
      this.scanningCode += String.fromCharCode(e.which);
      if (e.which == 13) { // 输入enter
        if (this.scanningCode != String.fromCharCode(e.which)) {
          this.getScanData(this.scanningCode);
          this.scanningCode = "";
        } else {
          this.scanningCode = "";
        }
      }
    }
    document.addEventListener("mousemove", () => {
      if (this.scanningCode != '') {
        this.scanningCode = '';
      }
    })
    this.getActivityData();
    this.getStaffList();
  },
  methods: {
    dialogSettlementSubmit (a) {
      this.dialogSettlementState = false;
      if (a == "success") {
        this.$confirm('充值成功', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.$emit("submit", 'success');
        })
      } else if (a == "fail") {
        this.$confirm('充值失败', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger'
        }).then(() => {
          this.$emit("submit", 'fail');
        })
      } else if (a == "cancel") {
        this.$emit("submit", 'cancel')
      }
    },
    // 删除服务和商品套餐
    delNotGoods (row) {
      if (row.index === undefined) { // 删二级
        let posi = this.o.searchDel(row.customCode);
        console.log("删二级商品" + posi + this.tableData[posi[0]].goodsList[posi[1]].customCode + this.tableData[posi[0]].goodsList[posi[1]].goodsName)
        this.$confirm('确定要删除?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.o.del(posi);
          this.tableData = this.o.arr;
        })
      } else {
        if (row.goodsType === 1) {
          let arrChildren = this.o.getOneChildren(row.index);
          let tableDel = [];
          for (let i = 0; i < arrChildren.length; i++) {
            let posi = this.o.searchDel(arrChildren[i])
            tableDel.push(this.tableData[posi[0]].goodsList[posi[1]]);
          }
          let str = '';
          for (let a = 0; a < tableDel.length; a++) {
            str = str + tableDel[a].customCode + tableDel[a].goodsName
          }
          console.log("删商品" + str)
          this.$confirm('确定要删除?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.o.del([row.index, -1]);
            this.tableData = this.o.arr;
          })
        }
      }

    },
    submit (state) {
      if (state == 'cancel') {
        this.$emit("submit", state)
      } else {
        let sales_list = [],
          pets_info = {},
          order_item_list = [];
        if (!this.activityList[this.curActivity]) {
          this.$message({
            message: '请选择充值活动',
            type: 'warning'
          });
          return;
        }
        if (!this.memberList[this.curPeople]) {
          this.$message({
            message: '请选择顾客',
            type: 'warning'
          });
          return;
        }
        if (this.curStaff.length == 0) {
          this.$message({
            message: '请选择销售人员',
            type: 'warning'
          });
          return;
        }
        if (this.activityList[this.curActivity].give_services.length > 0) { // 送服务选宠物
          if (this.curPet === '') {
            this.$message({
              message: '请选择宠物',
              type: 'warning'
            });
            return;
          } else {
            pets_info = {
              pets_id: this.memberList[this.curPeople].pets_info[this.curPet]._id,
              pets_name: this.memberList[this.curPeople].pets_info[this.curPet].nick_name,
            }
          }
        }
        if (this.activityList[this.curActivity].give_goods.length > 0) { // 送商品
          if (this.tableData.length == 0) {
            this.$message({
              message: '请录入商品',
              type: 'warning'
            });
            return;
          } else {
            let table2 = [];
            for (let i = 0; i < this.tableData.length; i++) {
              let one = {
                "goods_id": this.tableData[i].goodsId,
                "goods_name": this.tableData[i].goodsName,
                "goods_type": this.tableData[i].goodsType,
                "skus": this.tableData[i].skus,
                "sku_value": this.tableData[i].skuValue,
                "skuValue": this.tableData[i].skuValue,
                "unit": this.tableData[i].unit,
                model: this.tableData[i].skuValue,
                "original_price": this.tableData[i].originalPrice,
                "price": this.tableData[i].price,
                "num": this.tableData[i].num,
                "activityId": this.activityList[this.curActivity].activity_id,
                "activityName": this.activityList[this.curActivity].activity_name,
                "totalMoney": this.tableData[i].totalMoney,
                "goodsUsage": this.tableData[i].goodsUsage,
                "goodsDosage": this.tableData[i].goodsDosage,
                "order_item_goods_list": [],
                "remark": this.tableData[i].remark
              }
              for (let a = 0; a < this.tableData[i].goodsList.length; a++) {
                let two = {
                  "goods_id": this.tableData[i].goodsList[a].goodsId,
                  "goods_name": this.tableData[i].goodsList[a].goodsName,
                  "custom_code": this.tableData[i].goodsList[a].customCode,
                  "specificationPrice": 0,
                  "price": this.tableData[i].goodsList[a].price,
                  "skus": this.tableData[i].goodsList[a].skus,
                  "skuValue": this.tableData[i].goodsList[a].skuValue,
                  "model": this.tableData[i].goodsList[a].skus_type,
                  "unit": this.tableData[i].goodsList[a].unit,
                  "validity_stop_date": this.tableData[i].goodsList[a].validityStopDate.substr(0, 10)
                }
                one.order_item_goods_list.push(two)
              }
              table2.push(one)
            }
            order_item_list = table2
          }
        }
        for (let i = 0; i < this.curStaff.length; i++) {
          sales_list.push({
            sales_id: this.staffList[this.curStaff[i]]._id,
            sales_name: this.staffList[this.curStaff[i]].basic_info.nick_name,
          })
        }
        let params = {
          "activity_id": this.activityList[this.curActivity].activity_id,
          "remark": this.remark,
          "user_info": {
            "user_id": this.memberList[this.curPeople]._id,
            "nick_name": this.memberList[this.curPeople].basic_info.nick_name,
            "user_mobile": this.memberList[this.curPeople].basic_info.user_mobile,
          },
          "sales_list": sales_list,
          "pets_info": pets_info,
          "order_item_list": order_item_list
        }
        let loading = this.$loading();
        this.$http.post('/api/Order/CreateOrderRecharge', params).then(res => {
          if (res.code == 0) {
            this.order = res.data;
            this.dialogSettlementState = true;
          }
          loading.close();
        }).catch(() => {
          loading.close()
        })
      }
    },
    // 获取商品信息
    getScanData (code) {
      this.scanningCode = '';
      this.scanningCodeInput = '';
      code = (code).toString().trim();
      // if(code.length!==12){
      // 	this.$message({
      // 		message: '条码输入有误',
      // 		type: 'error'
      // 	});
      // 	return ;
      // }
      this.o.searchGoods(code).then(res => {
        // 判断条码是否可用
        if (res.customCodeStatus.id < 1 || res.customCodeStatus.id > 5) {
          this.$message({
            message: res.customCodeStatus.name,
            type: 'error'
          });
          return;
        } else {
          let addState = this.o.addGoods();
          if (addState === true) {
            console.log('添加成功')
          } else {
            if (addState.type == 'exist') {
              alert('该商品已经添加  ' + this.tableData[addState.position[0]].goodsList[addState.position[1]].goodsName)
            }
          }
        }
        this.tableData = this.o.arr;
        console.log('end')
      })
    },
    // 查找处方
    clickScanningCodeInput () {
      if (!this.scanningCodeInput) {
        this.$message({
          message: '请输入条码',
          type: 'error'
        });
        return;
      }
      this.getScanData(this.scanningCodeInput);
    },
    // 修改活动
    changeActivity () {
      this.curPeople = '';
      this.curPet = '';
      this.tableData = [];
      this.memberList = []
    },
    // 选中用户
    changePeople (i) {
      console.log(i)
      this.curPeople = i;
    },
    visibleChange (a) {
      if (a) {
        this.curPeople = '';
        this.curPet = '';
        // this.remoteMethod('');
      }
    },
    // 搜索用户信息
    remoteMethod (query) {
      this.cancelSource ? this.cancelSource() : '';
      let params = {
        "shop_id": '', //门店id
        "hs_vip": -1, //花生会员：0否；1是；-1不限
        "hs_pet": -1, //花生宠物：0否；1是；-1不限
        "class_name": '', //类别  '' 犬类； 猫类
        "field": 'member', //搜索对象:顾客,手机号：member;宠物：pet
        "keyword": query, //关键字
        "pageIndex": 1,
        "pageSize": 100,
      }
      this.loading = true;
      this.memberList = [];
      this.$http.post('/api/Member/List', params,
        {
          cancelToken: new this.$http.self.CancelToken((fn) => {
            this.cancelSource = fn
          })
        },
      ).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.memberList = res.data.data;
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取充值活动
    getActivityData () {
      this.$http.get('/api/Activity/GetRecharge', {}).then(res => {
        if (res.code == 0) {
          this.activityList = res.data;
        }
      })
    },
    // 获取销售人员列表
    getStaffList () {
      let params = {
        "keyword": '', //关键字
        "pageIndex": 1,
        "pageSize": 1000,
      }
      this.$http.get('/api/Staff/List', params).then(res => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      })
    },
    // 遍历规格名称
    FSkuCard (arr) {
      let arr1 = [];
      for (let i = 0; i < arr.length; i++) {
        arr1.push(arr[i].value)
      }
      return arr1.join(',')
    }
  }
}
</script>
<style lang="scss" scoped>
.comp {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .dialog {
    font-size: 16px;

    .title {
      color: #1a1a1a;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #979797;
    }

    .content {
      padding: 30px;

      .line {
        display: flex;
        margin-bottom: 10px;

        .label {
          width: 114px;
          line-height: 53px;
          height: 53px;
          background-color: #2ca2ff;
          text-align: center;
          color: #fff;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }

        .input {
          width: 240px;
          height: 53px;

          ::v-deep .el-input__inner {
            height: 53px;
            line-height: 53px;
            border-radius: 0 4px 4px 0;
          }
        }

        .select {
          ::v-deep .el-input__inner {
            height: 53px;
            width: 450px;
          }
        }

        .sousuo {
          width: 88px;
          height: 53px;
          line-height: 53px;
          text-align: center;
          border-radius: 4px;
          margin-left: 10px;
          background-color: #ffd138;
          cursor: pointer;
        }
      }

      .detail {
        padding: 10px 20px;

        .span {
          display: inline-block;
          margin-right: 15px;
        }
      }
    }

    .btns {
      display: flex;
      justify-content: center;
      font-size: 20px;
      padding: 20px 40px 30px;

      .cancel {
        width: 127px;
        line-height: 55px;
        border-radius: 4px;
        border: 1px solid #979797;
        cursor: pointer;
        text-align: center;
      }

      .submit {
        width: 127px;
        line-height: 55px;
        border-radius: 4px;
        margin-left: 60px;
        border: 1px solid #2ca2ff;
        text-align: center;
        cursor: pointer;
        background-color: #2ca2ff;
        color: #fff;
      }
    }
  }
}
</style>
